module.exports = __webpack_public_path__ + "static/media/Kate Foust.4a9f839f.png";